<template>
  <div id="app" :style="{ maxWidth: '100%' }">
    <global-header></global-header>

    <router-view :scWidth="width" />
    <!--    <global-mobile-footer v-if="deviceType === 'mobile'"></global-mobile-footer>-->
    <global-footer></global-footer>
  </div>
</template>
<script>
import globalHeader from "../src/components/header.vue";
import globalFooter from "../src/components/footer.vue";
// import globalMobileFooter from "../src/components/footer-m";
export default {
  components: {
    globalHeader,
    globalFooter,
    // globalMobileFooter,
  },
  data() {
    return {
      width: 1920,
      deviceType: localStorage.getItem("deviceType"),
    };
  },
  created() {
    // 获取设备的宽度
    this.width = window.innerWidth;
  },
  mounted() {
    this.init();
    // 获取token
    this.handleToken();
  },
  methods: {
    init() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        // console.log("手机端");
        localStorage.setItem("deviceType", "mobile");
      } else {
        // console.log("pc端");
        localStorage.setItem("deviceType", "pc");
      }
    },
    handleToken() {
      fetch(
        "http://www.uspacetech.com/api/api-uaa/oauth/token?grant_type=client_credentials&scope=all",
        // "http://www.hxyiliao.net:9900/api/api-uaa/oauth/token?grant_type=client_credentials&scope=all",
        {
          method: "post",
          headers: {
            Accept: "*/*",
            Authorization: "Basic emx0OnpsdA==",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          // console.log("res", res);
          localStorage.setItem("token", res.datas.access_token);
        });
    },
  },
};
</script>
<style lang="less">
#app {
  font-family: Microsoft YaHei Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
  min-width: 1200px;
}
/* 隐藏滚动条但仍可以滚动 */
.element {
  overflow: auto;
  scrollbar-width: none; /* 对于Firefox */
}

/* 针对Webkit内核浏览器如Chrome、Safari的滚动条样式 */
.element::-webkit-scrollbar {
  display: none !important; /* 隐藏滚动条 */
}

/* 针对IE和Edge的滚动条样式 */
.element {
  -ms-overflow-style: none; /* IE和Edge */
}
</style>
